// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"179":"main","328":"admin","625":"main_app"}[chunkId] + "." + {"179":"9c6a30bd","328":"f07032e5","625":"1db320cf"}[chunkId] + ".css";
};